<div class="container-fluid">
<section>
    <header>
        <h1><span jhiTranslate="germplasm-list.title">Germplasm Lists</span>&nbsp;
            <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
        </h1>
		<div class="d-flex">
			<div class="row col mb-3">
                <div class="col d-flex align-items-center">
                    <img  src="content/images/review-list-details.png" class="image-icon-md"/>
                    <div style="padding-top: 5px;">
                        <a href (click)="browseList($event)" jhiTranslate="germplasm-list.browse-link"></a>&nbsp;
                        <span jhiTranslate="germplasm-list.browse-text"></span>
                    </div>
                </div>
			</div>
			<button class="btn btn-outline-info ms-auto align-self-start float-end" (click)="toggleListBuilder()" *jhiHasAnyAuthority="CREATE_GERMPLASM_LIST_PERMISSIONS">
				<i class="fa me-3" [ngClass]="listBuilderContext.visible ? 'fa-angle-right': 'fa-angle-left'"></i>
				<span *ngIf="listBuilderContext.visible" jhiTranslate="list-builder.hide"></span>
				<span *ngIf="!listBuilderContext.visible" jhiTranslate="list-builder.show"></span>
			</button>
		</div>
    </header>
    <div class="row">
        <section [ngClass]="listBuilderContext.visible ? 'col-7' : 'col'">
            <nav>
                <!-- Nav tabs -->
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item pe-1 mt-1">
                        <a class="nav-link p-2" href="#germplasm-list" jhiTranslate="germplasm-list.nav.search" (click)="setSearchTabActive()"
                           [routerLink]="['germplasm-lists-search']" [class.active]="!hideSearchTab" queryParamsHandling="merge">Search</a>
                    </li>
                    <li class="nav-item pe-1 mt-1" *ngFor="let tab of tabs" role="presentation">
                        <a class="nav-link p-2" role="tab" data-bs-toggle="tab" (click)="setActive(tab.id)"
                           [routerLink]="['list/' + tab.id]" [routerLinkActive]="['active']" [queryParams]="{ listId: tab.id }" queryParamsHandling="merge">
                            {{tab.name}}
                            <i class="fa fa-times close-nav-tab" (click)="$event.stopPropagation(); closeTab(tab)"></i>
                        </a>
                    </li>
                </ul>
                <!-- TODO router-outlet sticky state? router-outlet not possible right now because we don't want to reload tabs  -->
                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane container-fluid row" [class.active]="!hideSearchTab">
                        <jhi-germplasm-list-search></jhi-germplasm-list-search>
                    </div>
                    <!-- Tab panes -->
                    <div *ngFor="let tab of tabs; trackBy: trackId" role="tabpanel" class="tab-pane container-fluid row p-3" [class.active]="tab.active" id="list-{{tab.id}}">
                        <div class="col-xs-12 col-md-12">
                            <jhi-list [listId]="tab.id"></jhi-list>
                        </div>
                    </div>
                </div>
            </nav>
        </section>
		<section [hidden]="!listBuilderContext.visible" class="col-5 h-auto">
			<jhi-list-builder [openListOnSave]="true"></jhi-list-builder>
		</section>
    </div>
</section>
</div>
